import {  } from "../constants";

export const clearLocalStorage = (key) => {
    const dev = localStorage.getItem("indi-device-type")
    const platform = localStorage.getItem("indi-platform")

    localStorage.clear();
    localStorage.setItem("indi-device-type", dev)
    localStorage.setItem("indi-platform", platform)
};